import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
	{
		key: 'login',
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() => import('views/auth-views/authentication/login')),
	}
];

export const protectedRoutes = [
    {
        key: 'MainCategory',
        path: `${APP_PREFIX_PATH}/Category/MainCategory`,
        component: React.lazy(() => import('views/app-views/project/mainCat/Main')),
    },
    {
        key: "TrafficRules",
        path: `${APP_PREFIX_PATH}/Category/TrafficRules`, 
        component: React.lazy(() => import('views/app-views/project/subCate/trafficRules/trafficRuleCate')),
    },
    {
        key: "SubTrafficRules",
        path: `${APP_PREFIX_PATH}/Category/SubTrafficRules`,  
        component: React.lazy(() => import('views/app-views/project/subCate/trafficRules/subTrafficRuleCate')),
    },
    // {
    //     key: "SubTrafficRulesDetails",
    //     path: `${APP_PREFIX_PATH}/Category/SubTrafficRulesDetails`,  
    //     component: React.lazy(() => import('views/app-views/project/subCate/trafficRules/subTrafficRuleCateDetails')),
    // },
    {
        key: "GeneralLaws",
        path: `${APP_PREFIX_PATH}/Category/GeneralLaws`,
        component: React.lazy(() => import('views/app-views/project/subCate/generalLaws/generalLawsCate')),
    },
    {
        key: "SubGeneralLaws",
        path: `${APP_PREFIX_PATH}/Category/SubGeneralLaws`,
        component: React.lazy(() => import('views/app-views/project/subCate/generalLaws/subGeneralLawsCate')),
    },
    {
        key: "OffenceAndFines",
        path: `${APP_PREFIX_PATH}/Category/OffenceAndFines`,
        component: React.lazy(() => import('views/app-views/project/subCate/offenceAndFines/offenceAndFinesCate')),
    },
    {
        key: "SubOffenceAndFines",
        path: `${APP_PREFIX_PATH}/Category/SubOffenceAndFines`,
        component: React.lazy(() => import('views/app-views/project/subCate/offenceAndFines/subOffenceAndFinesCate')),
    },
    {
        key: "OffenceAndFinesDetails",
        path: `${APP_PREFIX_PATH}/Category/OffenceAndFinesDetails`, 
        component: React.lazy(() => import('views/app-views/project/subCate/offenceAndFines/offenceAndFinesDetailsCate')),
    },
    {
        key: "OffenceAndFinesFurtherDetails",
        path: `${APP_PREFIX_PATH}/Category/OffenceAndFinesFurtherDetails`, 
        component: React.lazy(() => import('views/app-views/project/subCate/offenceAndFines/offenceFutherDetails')),
    },
    {
        key: "EmergencyContactDetails",
        path: `${APP_PREFIX_PATH}/Category/EmergencyContactDetails`, 
        component: React.lazy(() => import('views/app-views/project/subCate/emergencyContact/EmergencyContactDetails')),
    },
    {
        key: "Signs",
        path: `${APP_PREFIX_PATH}/Category/Signs`,
        component: React.lazy(() => import('views/app-views/project/subCate/signs/signsCate')),
    },
    {

        key: "SignsSubcategories",
        path: `${APP_PREFIX_PATH}/Category/SignsSubcategories`,
        component: React.lazy(() => import('views/app-views/project/subCate/signs/signsSubCate')),
    },
    {
        key: "Quiz",
        path: `${APP_PREFIX_PATH}/Category/Quiz`,
        component: React.lazy(() => import('views/app-views/project/quiz/quiz')),
    },
    {
        key: "States",
        path: `${APP_PREFIX_PATH}/Category/States`,
        component: React.lazy(() => import('views/app-views/project/states/states')),
    },
    {
        key: "Districts",
        path: `${APP_PREFIX_PATH}/Category/Districts`,
        component: React.lazy(() => import('views/app-views/project/districts/districts')),
    },
    {
        key: "FirstAid",
        path: `${APP_PREFIX_PATH}/Category/FirstAid`,     
        component: React.lazy(() => import('views/app-views/project/subCate/firstAid/firstAid')),
    },
    {
        key: "rto",
        path: `${APP_PREFIX_PATH}/Category/rto`,     
        component: React.lazy(() => import('views/app-views/project/subCate/rto/RTO')),
    },
    {
        key: "RTO_Codes",
        path: `${APP_PREFIX_PATH}/Category/rto_codes`,   
        component: React.lazy(() => import('views/app-views/project/subCate/rto/rto_codes')),
    },
]